module.exports = __webpack_public_path__ + "img/wallet.f320bdd8.png";